$(document).ready(function () {
  $('input[type="radio"]').on('change', function () {
    console.log("I am changed");
    const $button = $('#AddToCart'); 
    const hasClassDisabled = $button.hasClass('disabled');

    if (hasClassDisabled) {
      $('#out-of-stock-form').css('display', 'block');
    } else {
      $('#out-of-stock-form').css('display', 'none');
    }
  });
});